import React from "react";
import Banner from "../components/utilities/Banner";
// components
import VideoHeader from "../components/Media/VideoHeader";
import Event from "../components/Media/Event";
import NewsCom from "../components/Media/NewsCom";

// import YouTube from 'react-youtube';
function Media() {
  return (
    <div className="container ">
      <Banner />
      <VideoHeader />
      <Event />
      <NewsCom />
    </div>
  );
}

export default Media;
